import React, { useEffect, useState } from "react";
import BackPageBtn from "../Pages/BackButton/BackPageBtn";
import HomeServices from "../Services/HomeServices";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import DataTable from "react-data-table-component";
import HttpClientXml from "../utils/HttpClientXml";

const Documents = () => {
  const location = useLocation();
  const { userId, serviceId } = location?.state || {};
  const [documents, setDocuments] = useState([]);
  const [fetchDocumentLoading, setFetchDocumentLoading] = useState(false);
  const [fullData, setFullData] = useState(null);

  const fetchDocuments = async () => {
    setFetchDocumentLoading(true);
    const res = await HomeServices.viewUploadedDoc({ userId, serviceId });
    if (res && res?.status) {
      setDocuments(res?.data[0]?.ServiceDocuments);
      setFullData(res?.data[0]);
      console.log("documents", res);
      setFetchDocumentLoading(false);
    } else {
      setFetchDocumentLoading(false);
      toast.error("failed to fetch Documents Details");
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, []);

  const columns = [
    {
      name: "SL.NO",
      selector: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: "Document Name",
      selector: (row) => row?.document,
      sortable: true,
    },
    {
      name: "File",
      selector: (row) => (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {row?.Uploadedfile && (
            <div>
              <button
                disabled={loadingFile}
                onClick={() => {
                  handleDownload(row?.Uploadedfile?.file);
                }}
                className="btn btn-success btn-sm"
                style={{ marginLeft: "10px" }}
              >
                Download
              </button>
            </div>
          )}
          <div>
            <button disabled={loadingFile} className="btn btn-sm">
              <input
                style={{ cursor: "pointer", width: "80%" }}
                onChange={(e) => handleFileChange(e, row?._id)}
                type="file"
              />
            </button>
          </div>
        </div>
      ),
      sortable: true,
      center: true,
    },
  ];

  const handleDownload = (fileLink) => {
    const link = document.createElement("a");
    link.href = fileLink;

    link.download = "myImage.png";
    link.click();
  };
  const [loadingFile, setLoadingFile] = useState("");
  const [uploadedFile, setUploadedFile] = useState("");
  // Update file name when file is selected
  const handleFileChange = async (e, documentId) => {
    // const fileName = event.target.files[0]?.name || '';
    setLoadingFile("Uploading document. Please wait...");

    /////Uploading Single Image////
    const formData = new FormData();
    formData.append("image", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode(
        "image-upload",
        "POST",
        formData,
      );

      if (res && res.status) {
        setUploadedFile(res?.data?.url);
        ////Upload Document///////
        const formData = {
          userId: fullData?.userId,
          assignedServiceId: fullData?._id,
          serviceId: fullData?.serviceId,
          documentId: documentId,
          file: res?.data?.url,
          // uploadedBy: "admin"
        };

        // console.log("WFGN290",formData);
        // return

        try {
          const res = await HttpClientXml.requestRawData(
            "upload-documents",
            formData,
            "POST",
          );
          // console.log("TRE333", res);
          // return
          if (res && res.status) {
            toast.success(res?.message);
            fetchDocuments();
          } else {
            toast.error(res?.message);
          }
        } catch (error) {
          console.error("Error uploading document:", error);
          toast.error("Document upload failed.");
        }
        ///////////////////////
      } else {
        // toast.error(res?.message || "Image upload failed");
        console.error("Error uploading image:", res?.message);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      // toast.error("Image upload failed");
    }
    //////////////////////////////

    setLoadingFile("");
  };
  return (
    <div>
      <div className="d-flex justify-content-end mt-2">
        <div className="form-header">
          <BackPageBtn backLink="/users" />
        </div>
      </div>
      <div className="d-flex justify-content-end mt-2">
        <div className="form-header">
          {loadingFile && (
            <div
              style={{
                textAlign: "center",
                fontSize: "20px",
                fontWeight: "600",
                color: "green",
              }}
            >
              {" "}
              Uploading File...
            </div>
          )}
          <DataTable
            data={documents}
            columns={columns}
            progressPending={fetchDocumentLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default Documents;
